(() => {
  'use strict';
  const mount = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('[data-lv-cart-count]').forEach(node=>node.hidden=Number(node.textContent)===0);
    const mobileMenu=root.querySelector('.lv-menu');
    mobileMenu?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>mobileMenu.open=false));
    root.addEventListener('keydown',event=>{if(event.key==='Escape'&&mobileMenu?.open)mobileMenu.open=false;});
    const gallery = root.querySelector('[data-lv-gallery]');
    const slides = [...gallery.querySelectorAll('[data-lv-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-lv-thumb]')];
    let active = 0;
    const show = (index) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, n) => {
        slide.hidden = n !== active;
        if (n !== active) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach((thumb, n) => {
        thumb.classList.toggle('is-active', n === active);
        thumb.setAttribute('aria-pressed', String(n === active));
      });
      const thumb = thumbs[active];
      if (thumb) thumb.parentElement.scrollTo({left: thumb.offsetLeft - 12, behavior: 'smooth'});
    };
    thumbs.forEach((thumb,n) => thumb.addEventListener('click',()=>show(n)));
    gallery.querySelector('[data-lv-gallery-prev]').addEventListener('click',()=>show(active-1));
    gallery.querySelector('[data-lv-gallery-next]').addEventListener('click',()=>show(active+1));
    gallery.addEventListener('keydown',event=>{
      if (!event.target.closest('.lv-gallery__controls')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1)); thumbs[active]?.focus();
      }
    });
    let touchStart = null;
    gallery.querySelector('.lv-gallery__stage').addEventListener('touchstart',event=>{if(event.target.closest('video'))return;touchStart=event.changedTouches[0].clientX;},{passive:true});
    gallery.querySelector('.lv-gallery__stage').addEventListener('touchend',event=>{if(touchStart===null)return;const dx=event.changedTouches[0].clientX-touchStart;touchStart=null;if(Math.abs(dx)>40)show(active+(dx<0?1:-1));},{passive:true});
    const sizeDialog=root.querySelector('[data-lv-size-dialog]');
    const sizeOpener=root.querySelector('[data-lv-size-open]');
    sizeOpener?.addEventListener('click',()=>sizeDialog.showModal());
    root.querySelector('[data-lv-size-close]')?.addEventListener('click',()=>sizeDialog.close());
    sizeDialog?.addEventListener('click',event=>{if(event.target===sizeDialog){const r=sizeDialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)sizeDialog.close();}});
    sizeDialog?.addEventListener('close',()=>sizeOpener.focus({preventScroll:true}));
    const videoCarousel=root.querySelector('[data-lv-ugc-carousel]');
    if(videoCarousel){
      const track=videoCarousel.querySelector('[data-lv-ugc]');
      const cards=[...track.querySelectorAll('.lv-ugc__item')];
      const previous=videoCarousel.querySelector('[data-lv-ugc-prev]');
      const next=videoCarousel.querySelector('[data-lv-ugc-next]');
      const counter=videoCarousel.querySelector('[data-lv-ugc-status]');
      const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step=()=>cards[0]?.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0)||1;
      const update=()=>{
        const first=Math.min(cards.length,Math.floor((track.scrollLeft+2)/step())+1);
        const last=Math.min(cards.length,Math.ceil((track.scrollLeft+track.clientWidth-2)/step()));
        previous.disabled=track.scrollLeft<=2;
        next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
        const value=first+'–'+last+' / '+cards.length;
        if(counter.textContent!==value)counter.textContent=value;
      };
      const move=direction=>track.scrollBy({left:direction*step(),behavior:reduceMotion?'auto':'smooth'});
      previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
      if('ResizeObserver'in window)new ResizeObserver(update).observe(track);
      const inView=new Map(),userPaused=new WeakSet();
      const play=video=>{video.muted=true;video.play().catch(()=>{});};
      const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>{
        const video=entry.target;inView.set(video,entry.isIntersecting);
        if(entry.isIntersecting&&!userPaused.has(video)&&document.visibilityState==='visible')play(video);else video.pause();
      }),{threshold:.25}):null;
      cards.forEach((card,index)=>{
        const video=card.querySelector('video'),toggle=card.querySelector('[data-lv-video-toggle]');if(!video||!toggle)return;
        video.muted=true;if(reduceMotion)userPaused.add(video);
        const sync=()=>{card.classList.toggle('is-playing',!video.paused);toggle.setAttribute('aria-pressed',String(!video.paused));toggle.setAttribute('aria-label',(video.paused?'Odtwórz film ':'Wstrzymaj film ')+(index+1));};
        video.addEventListener('play',sync);video.addEventListener('pause',sync);sync();
        toggle.addEventListener('click',()=>{if(video.paused){userPaused.delete(video);play(video);}else{userPaused.add(video);video.pause();}});
        if(observer)observer.observe(video);else if(!reduceMotion)play(video);
      });
      document.addEventListener('visibilitychange',()=>inView.forEach((visible,video)=>{if(visible&&!userPaused.has(video)&&document.visibilityState==='visible')play(video);else video.pause();}));
      update();
    }
    const form = root.querySelector('.lv-product-form');
    if (!form) return;
    const atc = form.querySelector('[data-lv-atc]');
    const status = form.querySelector('[data-lv-form-status]');
    let pending = false;
    const syncThumbnails = () => {
      form.querySelectorAll('[data-lv-colour]').forEach(select=>{
        const image=select.closest('.lv-choice-row').querySelector('[data-lv-offer-thumbnail]');
        const source=select.selectedOptions[0]?.dataset.lvThumbSrc;
        if(image&&source&&image.getAttribute('src')!==source)image.src=source;
      });
    };
    const sync = () => {
      form.querySelectorAll('[data-lv-offer]').forEach(offer=>{
        const radio = offer.querySelector('[data-lv-variant]');
        const choices = offer.querySelector('[data-lv-choices]');
        offer.classList.toggle('is-selected',radio.checked);
        choices.hidden = !radio.checked;
        choices.disabled = !radio.checked;
      });
      const selected = form.querySelector('[data-lv-variant]:checked');
      const available = selected?.dataset.available === 'true';
      atc.disabled = pending || !available;
      atc.textContent = pending ? 'DODAWANIE…' : (available ? 'DODAJ DO KOSZYKA' : 'PRODUKT NIEDOSTĘPNY');
      atc.setAttribute('aria-busy',String(pending));
    };
    form.addEventListener('change',()=>{status.textContent='';syncThumbnails();sync();});
    form.addEventListener('submit',event=>{
      if (!window.LuvanoCart) return; // Native Shopify product form remains the fallback.
      event.preventDefault();
      if (pending) return;
      const radio = form.querySelector('[data-lv-variant]:checked');
      if (!radio || radio.dataset.available !== 'true') return;
      const properties = {};
      radio.closest('[data-lv-offer]').querySelectorAll('[data-lv-property]').forEach(select=>{
        const key = select.name.match(/^properties\[(.+)\]$/)?.[1];
        if (key) properties[key] = select.value;
      });
      pending = true;
      status.textContent = '';
      sync();
      window.dispatchEvent(new CustomEvent('luvano:add', {detail:{items:[{id:Number(radio.value),quantity:1,properties}],opener:atc}}));
    });
    window.addEventListener('luvano:add-result',event=>{
      if (!pending) return;
      pending = false;
      if (!event.detail?.success) status.textContent = event.detail?.error || (event.detail?.busy ? 'Poczekaj na zakończenie aktualizacji koszyka.' : 'Nie udało się dodać produktu. Spróbuj ponownie.');
      sync();
    });
    syncThumbnails();
    sync();
  };
  document.querySelectorAll('[data-lv-pdp]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lv-pdp]').forEach(mount));
  const backTop=document.querySelector('[data-lv-back-top]');
  if(backTop){const update=()=>backTop.hidden=window.scrollY<500;window.addEventListener('scroll',update,{passive:true});backTop.addEventListener('click',()=>window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));update();}
})();
